import React, { CSSProperties, ReactNode } from 'react';
import MUIButton from '@mui/material/Button';
import { useTranslation } from '@hooks/index';
import './styles.scss';
import { textToId } from '@utils/automation-test-helpers';

export interface IButtonProps {
    id?: string;
    size?: 'small' | 'medium' | 'large';
    secondary?: boolean;
    style?: CSSProperties | undefined;
    onClick?: (message: string) => void;
    component?: any; // eslint-disable-line
    disabled?: boolean;
    children?: ReactNode;
    text?: string | null;
    fullWidth?: boolean;
    className?: string;
    type?: string;
    outlined?: boolean;
    borderBtn?: boolean;
    'data-testid'?: string;
}

const Button = ({
    id,
    secondary,
    fullWidth,
    size,
    style,
    text,
    children,
    onClick,
    disabled,
    component,
    className,
    type,
    outlined,
    borderBtn,
    'data-testid': dataTestId,
}: IButtonProps) => {
    const { t } = useTranslation();

    return (
        <MUIButton
            id={id}
            data-testid={dataTestId ?? id ?? `button-${textToId(text ?? '')}`}
            variant={outlined ? 'text' : borderBtn ? 'outlined' : 'contained'}
            className={className}
            color={secondary ? 'secondary' : borderBtn ? 'inherit' : 'primary'}
            component={component}
            disabled={disabled}
            fullWidth={fullWidth}
            onClick={onClick}
            size={size}
            style={style}
            type={type}
            disableRipple
        >
            {text ? (text[0] === '@' ? text.substr(1) : t(text)) : children}
        </MUIButton>
    );
};

export default Button;
